import React from 'react';
import { useScreenInit } from './useScreenInit';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { InstagramFeed } from './components/InstagramFeed';
import { GridPanels } from './components/GridPanels';
import { EventCategories } from './components/EventCategories';
import { EventProcess } from './components/EventProcess';
import { MenuSection } from './components/MenuSection';
import { About } from './components/About';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { BookingForm } from './components/BookingForm';
import { ActionCTA } from './components/ActionCTA';
import { Footer } from './components/Footer';
export function App() {
  useScreenInit();
  return <div className="w-full min-h-full bg-canvas text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <InstagramFeed data-id="element-4" />
        <EventCategories data-id="element-5" />
        <EventProcess data-id="element-6" />
        <GridPanels data-id="element-7" />
        <MenuSection data-id="element-8" />
        <About data-id="element-9" />
        <Gallery data-id="element-10" />
        <Reviews data-id="element-11" />
        <BookingForm data-id="element-12" />
        <ActionCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}